<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="50px" viewBox="150 100 450 550" enable-background="new 0 0 600 750" xml:space="preserve">
<path fill="transparent" opacity="1.000000" stroke="none"
      d="
M485.000000,751.000000
	C323.333344,751.000000 162.166672,751.000000 1.000000,751.000000
	C1.000000,501.000000 1.000000,251.000000 1.000000,1.000000
	C251.000000,1.000000 501.000000,1.000000 751.000000,1.000000
	C751.000000,251.000000 751.000000,501.000000 751.000000,751.000000
	C662.500000,751.000000 574.000000,751.000000 485.000000,751.000000
M473.057861,358.995575
	C471.249603,371.647430 465.695496,382.753326 457.793579,392.469635
	C452.559296,398.905792 446.013062,404.274933 439.316711,410.024445
	C430.387421,416.734009 420.133392,420.933289 409.566467,423.746002
	C394.741364,427.692169 379.516876,428.203827 364.215759,426.060425
	C338.996063,422.527557 319.264282,409.504517 302.612305,391.015167
	C293.117371,380.472595 287.085938,367.954071 282.006531,354.064697
	C274.605225,331.723785 275.015381,309.478790 282.984589,286.538574
	C296.017151,252.973282 318.692719,229.547470 354.052826,219.987076
	C389.243408,210.472519 420.351196,218.712189 446.140137,241.921783
	C463.322479,226.053848 480.194946,210.472046 497.170135,194.795410
	C487.572784,184.764084 478.345490,177.558929 467.768036,171.591370
	C455.186829,164.493332 442.415771,158.128845 428.387573,154.860779
	C416.043091,151.984940 403.467712,150.100449 390.501495,147.091095
	C387.679504,147.071747 384.853760,146.950348 382.036377,147.054947
	C376.685394,147.253571 371.339172,147.581558 365.152374,147.974747
	C363.734314,148.314133 362.326813,148.708054 360.896545,148.984177
	C350.521423,150.987015 340.052185,152.590240 329.783844,155.037888
	C312.999237,159.038803 297.847626,166.972092 283.414886,176.166031
	C267.707733,186.171814 254.175003,198.821564 243.038666,213.661255
	C236.147430,222.844086 230.802185,233.187073 224.156815,243.338043
	C222.417877,247.310287 220.692459,251.288513 218.937683,255.253738
	C211.510391,272.036987 207.487762,289.785614 206.225372,307.913239
	C205.140945,323.485199 205.784119,339.143372 208.850677,354.676300
	C211.976639,370.510132 216.758026,385.645691 224.237610,400.677795
	C230.492477,410.551331 236.026978,420.989563 243.201523,430.142151
	C250.619843,439.605682 258.887482,448.719482 268.127075,456.362061
	C280.619720,466.695343 294.320953,475.628265 309.524200,481.776703
	C318.426392,485.376862 327.236176,489.582550 336.497498,491.815186
	C346.414093,494.205811 356.812134,494.599243 367.774017,496.013000
	C376.852417,496.034546 385.930847,496.056091 395.895844,496.017303
	C402.859680,495.079742 410.005981,494.833374 416.747406,493.053436
	C428.897095,489.845520 441.123901,486.505737 452.735565,481.786621
	C468.889740,475.221436 483.749084,466.193604 496.525085,452.959503
	C510.008270,440.770569 520.648193,426.249420 528.247559,409.956360
	C534.001648,397.619598 538.359619,384.448914 541.731140,371.238983
	C544.652527,359.792480 545.314209,347.769287 547.415466,335.605011
	C547.224182,328.802704 547.032898,322.000366 546.965332,314.333557
	C546.311951,308.985291 545.454773,303.652344 545.050415,298.285309
	C544.351440,289.009033 544.469360,289.000061 535.420898,289.000061
	C485.108521,289.000061 434.796143,289.000061 384.483765,289.000061
	C382.725464,289.000061 380.967194,289.000092 378.991730,289.000092
	C378.991730,311.472656 378.982697,333.279602 379.033112,355.086365
	C379.034729,355.775391 379.648682,356.463013 380.420258,357.895844
	C405.726624,357.926544 431.033020,357.936676 456.339294,358.003845
	C461.981720,358.018799 467.623657,358.234344 473.057861,358.995575
M234.550674,585.043823
	C235.375900,583.027649 235.639618,580.313843 237.125275,579.118225
	C243.014175,574.378967 249.285278,570.114624 256.346191,564.999512
	C247.538742,564.999512 239.802704,564.864258 232.075638,565.068604
	C229.140121,565.146240 227.778687,564.313660 226.902649,561.383667
	C224.653854,553.862427 221.980423,546.468262 219.476746,539.023254
	C216.554428,544.201233 214.452164,549.513428 213.070572,555.006836
	C210.568741,564.954468 210.748138,564.999573 200.813797,564.999573
	C197.817703,564.999573 194.821625,564.999573 191.825531,564.999573
	C188.713593,564.999573 185.601669,564.999573 181.138962,564.999573
	C188.214340,570.022827 193.740982,574.390259 199.711212,578.030029
	C203.725922,580.477600 204.379059,582.763855 202.597580,587.085510
	C199.877167,593.684998 197.999908,600.632141 195.345505,608.706726
	C204.084076,602.502319 211.621094,597.151001 219.004517,591.908752
	C226.639725,597.436035 233.969650,602.742249 242.324768,608.790649
	C239.552383,600.134644 237.248230,592.940613 234.550674,585.043823
M377.938629,539.846130
	C376.962219,540.695007 375.469696,541.360413 375.092346,542.422180
	C372.451355,549.853088 370.040771,557.365845 367.397003,565.333008
	C358.404205,565.333008 349.436127,565.333008 339.599396,565.333008
	C347.508392,571.025879 354.563995,576.104431 361.815582,581.324097
	C359.145081,590.043091 356.475098,598.760437 353.430756,608.700012
	C358.560425,604.881653 362.653320,601.928833 366.644867,598.844849
	C375.590759,591.932983 375.575317,591.897888 384.372345,597.143494
	C385.071198,597.560059 385.592957,598.262939 386.261719,598.742493
	C390.611023,601.861328 394.978210,604.955261 400.378510,608.796326
	C397.595612,600.308472 395.631958,593.131104 392.851257,586.285645
	C391.194122,582.206055 392.743042,580.099121 395.664551,578.063477
	C401.594299,573.931702 407.545807,569.831177 414.526428,564.999268
	C405.285797,564.999268 397.345001,565.106445 389.412140,564.903076
	C387.936371,564.865234 385.576904,563.908142 385.182312,562.813843
	C382.550293,555.514832 380.340942,548.063477 377.938629,539.846130
M270.378632,572.057251
	C273.249359,574.205017 275.929932,576.696777 279.038147,578.414795
	C283.056366,580.635742 283.223572,583.071716 281.586121,587.098145
	C278.902679,593.696594 277.008392,600.616028 274.428894,608.473450
	C283.092163,602.456665 290.676331,597.189331 297.980865,592.116211
	C305.655914,597.523132 313.019684,602.710815 321.365875,608.590637
	C318.039154,598.597168 315.199127,590.065735 312.365173,581.552612
	C319.748596,576.183105 327.068939,570.859436 335.126648,564.999573
	C326.563599,564.999573 319.063202,564.757263 311.589600,565.099548
	C307.723938,565.276672 305.995422,563.858337 305.019379,560.313660
	C303.039276,553.122437 300.774200,546.009705 298.626587,538.864624
	C298.181915,538.881165 297.737213,538.897644 297.292542,538.914185
	C294.364655,547.544556 291.436737,556.174927 288.345825,565.285767
	C279.435608,565.285767 270.453247,565.285767 260.843597,565.285767
	C264.224792,567.842163 266.939728,569.894775 270.378632,572.057251
M471.941650,586.720093
	C471.411957,584.919312 470.882263,583.118469 470.404541,581.494324
	C477.691650,576.130798 484.724518,570.954346 492.814941,564.999573
	C484.154510,564.999573 476.988007,564.672791 469.870819,565.123779
	C465.687103,565.388855 464.080078,563.689819 462.999359,560.090393
	C460.875122,553.015686 458.459747,546.028503 456.164825,539.005066
	C455.752472,539.002380 455.340118,538.999634 454.927765,538.996948
	C452.146027,547.637817 449.364319,556.278625 446.507965,565.151306
	C437.386780,565.151306 428.484711,565.151306 418.545837,565.151306
	C426.620453,571.091614 433.864014,576.420471 440.892731,581.591309
	C438.040314,590.391724 435.310059,598.815063 432.579834,607.238464
	C437.563202,604.814880 441.582672,602.051880 445.419342,599.054871
	C455.430298,591.234619 455.793976,591.304688 465.952026,599.500977
	C469.853943,602.649353 474.216583,605.226685 479.013092,608.504089
	C476.477203,600.914429 474.239227,594.216492 471.941650,586.720093
M554.281738,606.046570
	C555.073120,606.586060 555.864502,607.125610 557.874390,608.495911
	C555.482483,601.181152 553.727356,594.982117 551.415833,588.997925
	C549.424988,583.843689 548.292297,579.744690 555.317810,577.497864
	C558.033264,576.629395 560.118408,573.831848 562.532166,571.966858
	C565.251404,569.865784 568.017334,567.825195 571.829590,564.955261
	C561.355103,564.955261 552.399780,564.955261 543.656250,564.955261
	C540.755676,556.134583 537.950439,547.603760 535.145203,539.072998
	C531.951477,544.732117 529.970825,550.167114 528.107483,555.641907
	C524.926208,564.989014 524.957153,564.999573 515.351624,564.999573
	C509.727142,564.999573 504.102692,564.999573 497.200287,564.999573
	C505.702393,571.166931 512.905762,576.392151 519.941101,581.495544
	C517.076172,590.297302 514.322937,598.756042 511.569641,607.214844
	C518.961853,603.048462 525.254883,598.272217 531.812561,593.892395
	C533.084045,593.043213 535.878662,593.008972 537.131775,593.849548
	C542.771179,597.632324 548.108215,601.865723 554.281738,606.046570
z"/>
        <path fill="#EB4435" opacity="1.000000" stroke="none"
              d="
M390.994293,147.778137
	C403.467712,150.100449 416.043091,151.984940 428.387573,154.860779
	C442.415771,158.128845 455.186829,164.493332 467.768036,171.591370
	C478.345490,177.558929 487.572784,184.764084 497.170135,194.795410
	C480.194946,210.472046 463.322479,226.053848 446.140137,241.921783
	C420.351196,218.712189 389.243408,210.472519 354.052826,219.987076
	C318.692719,229.547470 296.017151,252.973282 282.546509,286.885406
	C281.362823,286.898560 280.511505,286.700043 279.886993,286.211548
	C261.498444,271.828461 243.132507,257.416595 224.762955,243.009277
	C230.802185,233.187073 236.147430,222.844086 243.038666,213.661255
	C254.175003,198.821564 267.707733,186.171814 283.414886,176.166031
	C297.847626,166.972092 312.999237,159.038803 329.783844,155.037888
	C340.052185,152.590240 350.521423,150.987015 360.896545,148.984177
	C362.326813,148.708054 363.734314,148.314133 366.037842,147.953888
	C374.946960,147.881393 382.970612,147.829773 390.994293,147.778137
z"/>
        <path fill="#35A953" opacity="1.000000" stroke="none"
              d="
M495.931885,453.352966
	C483.749084,466.193604 468.889740,475.221436 452.735565,481.786621
	C441.123901,486.505737 428.897095,489.845520 416.747406,493.053436
	C410.005981,494.833374 402.859680,495.079742 395.085144,495.832642
	C385.182983,495.720123 376.091522,495.792236 367.000031,495.864380
	C356.812134,494.599243 346.414093,494.205811 336.497498,491.815186
	C327.236176,489.582550 318.426392,485.376862 309.524200,481.776703
	C294.320953,475.628265 280.619720,466.695343 268.127075,456.362061
	C258.887482,448.719482 250.619843,439.605682 243.201523,430.142151
	C236.026978,420.989563 230.492477,410.551331 224.494598,400.207397
	C243.890991,384.763153 263.030396,369.789307 282.169800,354.815491
	C287.085938,367.954071 293.117371,380.472595 302.612305,391.015167
	C319.264282,409.504517 338.996063,422.527557 364.215759,426.060425
	C379.516876,428.203827 394.741364,427.692169 409.566467,423.746002
	C420.133392,420.933289 430.387421,416.734009 439.792664,410.385315
	C458.040466,424.712189 475.806976,438.685089 493.607391,452.614594
	C494.207428,453.084137 495.149353,453.116699 495.931885,453.352966
z"/>
        <path fill="#4285F5" opacity="1.000000" stroke="none"
              d="
M496.228485,453.156219
	C495.149353,453.116699 494.207428,453.084137 493.607391,452.614594
	C475.806976,438.685089 458.040466,424.712189 440.161377,410.433960
	C446.013062,404.274933 452.559296,398.905792 457.793579,392.469635
	C465.695496,382.753326 471.249603,371.647430 473.342438,358.344421
	C473.045532,357.468170 472.463959,357.046021 471.882538,357.046265
	C441.247406,357.058685 410.612274,357.106842 379.977142,357.151276
	C379.648682,356.463013 379.034729,355.775391 379.033112,355.086365
	C378.982697,333.279602 378.991730,311.472656 378.991730,289.000092
	C380.967194,289.000092 382.725464,289.000061 384.483765,289.000061
	C434.796143,289.000061 485.108521,289.000061 535.420898,289.000061
	C544.469360,289.000061 544.351440,289.009033 545.050415,298.285309
	C545.454773,303.652344 546.311951,308.985291 546.654541,315.078735
	C546.554016,322.549591 546.764343,329.275269 546.974731,336.000977
	C545.314209,347.769287 544.652527,359.792480 541.731140,371.238983
	C538.359619,384.448914 534.001648,397.619598 528.247559,409.956360
	C520.648193,426.249420 510.008270,440.770569 496.228485,453.156219
z"/>
        <path fill="#FBBD05" opacity="1.000000" stroke="none"
              d="
M282.088165,354.440094
	C263.030396,369.789307 243.890991,384.763153 224.440643,399.858093
	C216.758026,385.645691 211.976639,370.510132 208.850677,354.676300
	C205.784119,339.143372 205.140945,323.485199 206.225372,307.913239
	C207.487762,289.785614 211.510391,272.036987 218.937683,255.253738
	C220.692459,251.288513 222.417877,247.310287 224.459885,243.173660
	C243.132507,257.416595 261.498444,271.828461 279.886993,286.211548
	C280.511505,286.700043 281.362823,286.898560 282.467377,287.278503
	C275.015381,309.478790 274.605225,331.723785 282.088165,354.440094
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M234.747375,585.395203
	C237.248230,592.940613 239.552383,600.134644 242.324768,608.790649
	C233.969650,602.742249 226.639725,597.436035 219.004517,591.908752
	C211.621094,597.151001 204.084076,602.502319 195.345505,608.706726
	C197.999908,600.632141 199.877167,593.684998 202.597580,587.085510
	C204.379059,582.763855 203.725922,580.477600 199.711212,578.030029
	C193.740982,574.390259 188.214340,570.022827 181.138962,564.999573
	C185.601669,564.999573 188.713593,564.999573 191.825531,564.999573
	C194.821625,564.999573 197.817703,564.999573 200.813797,564.999573
	C210.748138,564.999573 210.568741,564.954468 213.070572,555.006836
	C214.452164,549.513428 216.554428,544.201233 219.476746,539.023254
	C221.980423,546.468262 224.653854,553.862427 226.902649,561.383667
	C227.778687,564.313660 229.140121,565.146240 232.075638,565.068604
	C239.802704,564.864258 247.538742,564.999512 256.346191,564.999512
	C249.285278,570.114624 243.014175,574.378967 237.125275,579.118225
	C235.639618,580.313843 235.375900,583.027649 234.747375,585.395203
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M377.966492,540.253845
	C380.340942,548.063477 382.550293,555.514832 385.182312,562.813843
	C385.576904,563.908142 387.936371,564.865234 389.412140,564.903076
	C397.345001,565.106445 405.285797,564.999268 414.526428,564.999268
	C407.545807,569.831177 401.594299,573.931702 395.664551,578.063477
	C392.743042,580.099121 391.194122,582.206055 392.851257,586.285645
	C395.631958,593.131104 397.595612,600.308472 400.378510,608.796326
	C394.978210,604.955261 390.611023,601.861328 386.261719,598.742493
	C385.592957,598.262939 385.071198,597.560059 384.372345,597.143494
	C375.575317,591.897888 375.590759,591.932983 366.644867,598.844849
	C362.653320,601.928833 358.560425,604.881653 353.430756,608.700012
	C356.475098,598.760437 359.145081,590.043091 361.815582,581.324097
	C354.563995,576.104431 347.508392,571.025879 339.599396,565.333008
	C349.436127,565.333008 358.404205,565.333008 367.397003,565.333008
	C370.040771,557.365845 372.451355,549.853088 375.092346,542.422180
	C375.469696,541.360413 376.962219,540.695007 377.966492,540.253845
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M270.016663,572.002319
	C266.939728,569.894775 264.224792,567.842163 260.843597,565.285767
	C270.453247,565.285767 279.435608,565.285767 288.345825,565.285767
	C291.436737,556.174927 294.364655,547.544556 297.292542,538.914185
	C297.737213,538.897644 298.181915,538.881165 298.626587,538.864624
	C300.774200,546.009705 303.039276,553.122437 305.019379,560.313660
	C305.995422,563.858337 307.723938,565.276672 311.589600,565.099548
	C319.063202,564.757263 326.563599,564.999573 335.126648,564.999573
	C327.068939,570.859436 319.748596,576.183105 312.365173,581.552612
	C315.199127,590.065735 318.039154,598.597168 321.365875,608.590637
	C313.019684,602.710815 305.655914,597.523132 297.980865,592.116211
	C290.676331,597.189331 283.092163,602.456665 274.428894,608.473450
	C277.008392,600.616028 278.902679,593.696594 281.586121,587.098145
	C283.223572,583.071716 283.056366,580.635742 279.038147,578.414795
	C275.929932,576.696777 273.249359,574.205017 270.016663,572.002319
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M471.971436,587.119263
	C474.239227,594.216492 476.477203,600.914429 479.013092,608.504089
	C474.216583,605.226685 469.853943,602.649353 465.952026,599.500977
	C455.793976,591.304688 455.430298,591.234619 445.419342,599.054871
	C441.582672,602.051880 437.563202,604.814880 432.579834,607.238464
	C435.310059,598.815063 438.040314,590.391724 440.892731,581.591309
	C433.864014,576.420471 426.620453,571.091614 418.545837,565.151306
	C428.484711,565.151306 437.386780,565.151306 446.507965,565.151306
	C449.364319,556.278625 452.146027,547.637817 454.927765,538.996948
	C455.340118,538.999634 455.752472,539.002380 456.164825,539.005066
	C458.459747,546.028503 460.875122,553.015686 462.999359,560.090393
	C464.080078,563.689819 465.687103,565.388855 469.870819,565.123779
	C476.988007,564.672791 484.154510,564.999573 492.814941,564.999573
	C484.724518,570.954346 477.691650,576.130798 470.404541,581.494324
	C470.882263,583.118469 471.411957,584.919312 471.971436,587.119263
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M553.918030,605.991577
	C548.108215,601.865723 542.771179,597.632324 537.131775,593.849548
	C535.878662,593.008972 533.084045,593.043213 531.812561,593.892395
	C525.254883,598.272217 518.961853,603.048462 511.569641,607.214844
	C514.322937,598.756042 517.076172,590.297302 519.941101,581.495544
	C512.905762,576.392151 505.702393,571.166931 497.200287,564.999573
	C504.102692,564.999573 509.727142,564.999573 515.351624,564.999573
	C524.957153,564.999573 524.926208,564.989014 528.107483,555.641907
	C529.970825,550.167114 531.951477,544.732117 535.145203,539.072998
	C537.950439,547.603760 540.755676,556.134583 543.656250,564.955261
	C552.399780,564.955261 561.355103,564.955261 571.829590,564.955261
	C568.017334,567.825195 565.251404,569.865784 562.532166,571.966858
	C560.118408,573.831848 558.033264,576.629395 555.317810,577.497864
	C548.292297,579.744690 549.424988,583.843689 551.415833,588.997925
	C553.727356,594.982117 555.482483,601.181152 557.874390,608.495911
	C555.864502,607.125610 555.073120,606.586060 553.918030,605.991577
z"/>
        <path fill="#FEF9F9" opacity="1.000000" stroke="none"
              d="
M380.198700,357.523560
	C410.612274,357.106842 441.247406,357.058685 471.882538,357.046265
	C472.463959,357.046021 473.045532,357.468170 473.446411,358.025391
	C467.623657,358.234344 461.981720,358.018799 456.339294,358.003845
	C431.033020,357.936676 405.726624,357.926544 380.198700,357.523560
z"/>
        <path fill="#7EC58C" opacity="1.000000" stroke="none"
              d="
M367.387024,495.938690
	C376.091522,495.792236 385.182983,495.720123 394.641846,495.862854
	C385.930847,496.056091 376.852417,496.034546 367.387024,495.938690
z"/>
        <path fill="#FEF9F9" opacity="1.000000" stroke="none"
              d="
M547.195068,335.802979
	C546.764343,329.275269 546.554016,322.549591 546.592651,315.510986
	C547.032898,322.000366 547.224182,328.802704 547.195068,335.802979
z"/>
        <path fill="#FBB13A" opacity="1.000000" stroke="none"
              d="
M390.747894,147.434631
	C382.970612,147.829773 374.946960,147.881393 366.457153,147.894424
	C371.339172,147.581558 376.685394,147.253571 382.036377,147.054947
	C384.853760,146.950348 387.679504,147.071747 390.747894,147.434631
z"/>
</svg>
</template>

<script>
export default {
    name: 'GoogleIcon',
}
</script>